export default __webpack_public_path__ + "static/media/crop_pattern_winter_summer.f19e65ad.jpg";